import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Ml = () => {
  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: "#f4f6f9" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #3E826D, #3E826D)",
            color: "white",
            padding: "100px 0",
          }}
        >
          <Container className="text-center">
            <h1 className="fw-bold mb-4">Advanced Analytics</h1>
            <p className="lead" style={{ maxWidth: "800px", margin: "0 auto" }}>
              From Data to Foresight. We apply high-performance Deep Learning
              to solve the most complex environmental and social challenges.
            </p>
          </Container>
        </div>

        <Container className="py-5">
          {/* Machine Learning & Sentiment Tracking */}
          <Row className="mb-5">
            <Col className="text-center">
              <h2 className="fw-bold mb-3" style={{ color: "#3E826D" }}>
              Deep Learning & Sentiment Tracking
              </h2>
              <p className="text-muted">
                Move beyond complaint logs and understand the true pulse of your
                project.
              </p>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            {[
              {
                title: "Real-Time Sentiment Mapping",
                text: "Capture stakeholder concerns in real-time to inform Double Materiality assessments.",
              },
              {
                title: "Social Risk Heatmaps",
                text: "Visualize sentiment geographically and topically to identify emerging risks early.",
              },
              {
                title: "Beyond Complaints",
                text: "Shift from reactive management to proactive strategy with sentiment intelligence.",
              },
            ].map((item, index) => (
              <Col md={4} key={index}>
                <Card
                  className="h-100 border-0 shadow-sm rounded-4"
                  style={{ transition: "0.3s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-8px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0px)")
                  }
                >
                  <Card.Body>
                    <Card.Title
                      className="fw-bold"
                      style={{ color: "#3E826D" }}
                    >
                      {item.title}
                    </Card.Title>
                    <Card.Text className="text-muted mt-3">
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Strategic Scenario Modelling */}
          <div
            className="p-5 rounded-4 mb-5 shadow-sm"
            style={{ backgroundColor: "#eaf2ff" }}
          >
            <Row className="mb-4">
              <Col>
                <h2 className="fw-bold" style={{ color: "#3E826D" }}>
                  Strategic Scenario Modelling (SEA 2050)
                </h2>
                <p className="text-muted">
                  Data-driven future-casting for long-term resilience.
                </p>
              </Col>
            </Row>

            <Row className="g-4">
              {[
                "25-Year Forecasting — Predict environmental and social shifts decades ahead.",
                "Strategic Environmental Assessment (SEA) to de-risk high-stakes investments.",
                "Complex Data Synthesis — From satellite imagery to local economic trends.",
              ].map((text, index) => (
                <Col md={4} key={index}>
                  <Card className="border-0 rounded-4 shadow-sm h-100">
                    <Card.Body>
                      <Card.Text className="text-muted fw-semibold">
                        {text}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          {/* Assurance-Ready Traceability */}
          <Row className="mb-4 text-center">
            <Col>
              <h2 className="fw-bold text-success">
                Assurance-Ready Traceability
              </h2>
              <p className="text-muted">
                Every insight backed by a defensible digital audit trail.
              </p>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            {[
              "Digital Audit Trails — Secure logging of interactions for transparency.",
              "Lender & Investor Confidence — Direct insight access for auditors.",
              "Traceable Decisions — Every analytical output tied to verified source data.",
            ].map((text, index) => (
              <Col md={4} key={index}>
                <Card
                  className="border-0 shadow-sm rounded-4 text-center p-4 h-100"
                  style={{ transition: "0.3s" }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Card.Body>
                    <Card.Text className="text-muted fw-semibold">
                      {text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Why Choose Section */}
          <Row className="text-center mb-5">
            <Col>
              <h2 className="fw-bold mb-4" style={{ color: "#3E826D" }}>
                Why Choose Our Analytics Engine?
              </h2>
            </Col>
          </Row>

          <Row className="g-4 mb-5">
            {[
              "Expert-Designed — Built by E&S professionals who understand real-world impact.",
              "Predictive, Not Reactive — Identify risks before escalation.",
              "Full Lifecycle Integration — From scenario modeling to real-time tracking.",
            ].map((text, index) => (
              <Col md={4} key={index}>
                <Card className="border-0 shadow-sm rounded-4 text-center p-4 h-100">
                  <Card.Body>
                    <Card.Text className="text-muted fw-semibold">
                      {text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* CTA */}
          <Row className="text-center mb-5">
            <Col style={{
                  marginBottom: window.innerWidth < 768 ? "33px" : "0px",
                }}>
              <Button
                variant="success"
                size="lg"
                href="mailto:info@essolutions.ai?subject=Advanced Analytics Inquiry"
                className="px-5 py-3 rounded-pill shadow"
              >
                Discuss Your Complex Data Needs
              </Button>
            </Col>
            <Col>
              <Button
                variant="success"
                size="lg"
                href="https://www.seas2050.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-5 py-3 rounded-pill shadow"
              >
                SEA'S FOR 2050
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Ml;
